export default __webpack_public_path__ + "static/personalfundraise-5-9153f53da57a2955463bd8c5d9f40f0e.png";